import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Newspaper } from "lucide-react";

import { shortDate } from "@/utils/format";

function Thumb({ chronicle }) {
  if (!chronicle.image) {
    return <div className="flex h-16 w-20 shrink-0 items-center justify-center border border-white/10 bg-white/[0.04] text-slate-500"><Newspaper className="h-5 w-5" /></div>;
  }
  return <img src={chronicle.image} alt="" loading="lazy" className="h-16 w-20 shrink-0 object-cover image-treatment" onError={(event) => { event.currentTarget.style.visibility = "hidden"; }} />;
}

function localToday() {
  const now = new Date();
  return [now.getFullYear(), String(now.getMonth() + 1).padStart(2, "0"), String(now.getDate()).padStart(2, "0")].join("-");
}

export function HeroChronicleStrip({ chronicles = [] }) {
  const today = localToday();
  const latest = chronicles
    .filter((item) => {
      const expires = item.front_until || (["Sorteo de escuadras", "General"].includes(item.category) ? item.date : null);
      return !expires || expires >= today;
    })
    .sort((a, b) => (b.date || "").localeCompare(a.date || ""))
    .slice(0, 4);
  if (!latest.length) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.95, duration: 0.7 }} className="lg:col-span-2" data-testid="hero-chronicle-strip">
      <div className="mb-2 flex items-center gap-3">
        <p className="eyebrow">Últimas publicaciones</p>
        <a href="#cronicas" className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400 hover:text-clay" data-testid="hero-chronicle-strip-all">Ver todas →</a>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {latest.map((chronicle) => (
          <Link key={chronicle.id} to={chronicle.slug ? `/cronica/${chronicle.slug}` : "/#cronicas"} className="group flex items-center gap-4 border border-white/15 bg-charcoal/55 p-3 backdrop-blur transition-colors hover:border-clay/60 hover:bg-charcoal/75" data-testid={`hero-chronicle-${chronicle.id}`}>
            <Thumb chronicle={chronicle} />
            <div className="min-w-0">
              <p className="font-mono text-[9px] uppercase tracking-[0.22em] text-clay">{shortDate(chronicle.date)} {chronicle.date?.slice(0, 4)} · {chronicle.location}</p>
              <p className="mt-1 line-clamp-2 font-display text-lg uppercase leading-[0.95] text-slate-50 group-hover:text-clay">{chronicle.title}</p>
              {chronicle.category && chronicle.category !== "Crónica" ? <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500">{chronicle.category}</p> : null}
            </div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
}
